import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Could not connect to {providerName}',
    id: 'SwedbankSavingsbankErrorOverlay.title',
  },
  text: {
    defaultMessage: 'Maybe you are a customer of {providerName}?',
    id: 'SwedbankSavingsbankErrorOverlay.text',
  },
  primaryButtonLabel: {
    defaultMessage: `Log in to {providerName}`,
    id: 'SwedbankSavingsbankErrorOverlay.primaryButtonLabel',
  },
});
